import React, { useRef } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import SwiperType, { Autoplay, Navigation } from 'swiper';

import { Wrapper } from '~/styles/Wrapper.styled';
import { StyledTestimonials } from './Testimonials.styled';

import { Quote } from '~/types/types';
import ArrowSVG from '~/assets/images/icons/arrow.svg';

export const Testimonials: React.FC<TestimonialsData> = ({ testimonials }) => {
  const swiperRef = useRef<SwiperType>(null);

  const handleNext = () => {
    swiperRef.current?.slideNext();
  }

  const handlePrev = () => {
    swiperRef.current?.slidePrev();
  }

  return (
    <StyledTestimonials>
      <button onClick={handlePrev} className="back-button">
        <div className="swiper-button-prev"></div>
      </button>
      <button onClick={handleNext} className="next-button">
        <div className="swiper-button-next"></div>
      </button>
      <Wrapper gutter={false} width="thin">
        <h4>What people say</h4>
        <Swiper
          enabled={testimonials.length > 1}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          onSwiper={_ref => {
            swiperRef.current = _ref;
          }}
          // navigation={true}
          loop={true}
          slidesPerView={1}
          modules={[Autoplay, Navigation]}
        >
          {testimonials.map((testimonial, index) => {
            return (
              <SwiperSlide key={`testimonial-${index}`}>
                <div className="content">
                  <blockquote>
                    <div className="quote">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: testimonial.body.childMarkdownRemark.html,
                        }}
                      ></p>
                    </div>

                    <cite>
                      {testimonial.avatar && (
                        <figure>
                          <GatsbyImage
                            image={testimonial.avatar.gatsbyImageData}
                            alt={testimonial.avatar.title}
                          />
                        </figure>
                      )}

                      <span>
                        {testimonial.authorName}
                        {testimonial.location
                          ? `, ${testimonial.location}`
                          : ''}
                      </span>
                    </cite>
                  </blockquote>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="mobile-arrows">
          <button className="prev" onClick={handlePrev}>
            <ArrowSVG />
          </button>
          <button className="next" onClick={handleNext}>
            <ArrowSVG />
          </button>
        </div>
      </Wrapper>
    </StyledTestimonials>
  );
};

export interface TestimonialsData {
  testimonials: Quote[];
}
